import './terms-and-conditions.scss'
import '@client/layouts/layout_common/layout_common'
